export const FILL_LIST = 'FILL_LIST';
export const CHANGE_RECORD_STATUS = 'CHANGE_RECORD_STATUS';
export const FILL_DETAILS = 'FILL_DETAILS';
